import { useQuery } from '@tanstack/react-query';

import { channelDashboardApi } from '../services/channelDashboardApi';

export const useChannelDashboardOverview = (channelId: string | undefined) =>
  useQuery({
    queryKey: ['channel-dashboard', channelId, 'overview'],
    queryFn: () => channelDashboardApi.getOverview(channelId!),
    enabled: !!channelId,
    staleTime: 60_000,
  });
